import { Alert, Box, Button, Stack, Typography } from '@mui/material';
import {
  FC,
  useEffect,
  useState,
  Dispatch,
  SetStateAction,
} from 'react';

import {
  ApplicationQuestion,
} from '@features/applicationQuestions';
import ApplicationQuestionListItem from '@features/applicationQuestions/components/ApplicationQuestionListItem/ApplicationQuestionListItem';
import { useGetApplicationQuestions } from '@features/applicationQuestions/hooks/useGetApplicationQuestions';
import { Add } from '@mui/icons-material';
import ApplicationQuestionModal from '@features/applicationQuestions/components/ApplicationQuestionModal/ApplicationQuestionModal';
import { useGetEmployerTags } from '@features/applications/hooks/useGetEmployerTags';

type AddQuestionsStep = {
  setHasQuestion: Dispatch<SetStateAction<boolean>>;
  hasQuestions: boolean;
};

const AddQuestionsStep: FC<AddQuestionsStep> = ({
  setHasQuestion,
  hasQuestions,
}) => {
  const [errorText, setErrorText] = useState<string>('');

  const [isApplicationQuestionModalOpen, setIsApplicationQuestionModalOpen] =
    useState(false);

  const { tagsData: employerTagData } = useGetEmployerTags({
    setErrorText,
    enabled: true,
  });

  const { applicationsQuestionData } = useGetApplicationQuestions({
    setErrorText,
  });

  useEffect(() => {
    if (
      applicationsQuestionData?.object &&
      applicationsQuestionData?.object?.length > 0
    ) {
      setHasQuestion(true);
    }
  }, [applicationsQuestionData]);

  return (
    <Stack justifyContent="center" spacing={2} direction="column">
      {errorText && <Alert severity="error">{errorText}</Alert>}
      {applicationsQuestionData?.object &&
        applicationsQuestionData?.object?.length > 0 && (
          <Box>
            {applicationsQuestionData?.object.map(
              (question: ApplicationQuestion, index: number) => (
                <ApplicationQuestionListItem
                  question={question}
                  index={index}
                />
              ),
            )}
          </Box>
        )}
      <Button
        variant="contained"
        sx={{
          padding: '5px 50px !important',
          alignSelf: 'center',
          width: 'fit-content',
        }}
        startIcon={<Add />}
        onClick={() => {
          setIsApplicationQuestionModalOpen(true);
        }}
      >
        Add {!hasQuestions && 'a'} Question
      </Button>
      {!hasQuestions && (
        <Typography
          lineHeight={1.2}
          fontSize={16}
          sx={{ margin: '40px 0  10px 0 !important' }}
          color="gray"
          alignSelf="center"
          dangerouslySetInnerHTML={{
            __html: 'Want to do this later? No problem!',
          }}
        />
      )}

      {isApplicationQuestionModalOpen && (
        <ApplicationQuestionModal
          isOpen={isApplicationQuestionModalOpen}
          employerTagData={employerTagData}
          applicationQuestion={null}
          fromOnboarding={true}
          handleClose={() => {
            setIsApplicationQuestionModalOpen(false);
          }}
        />
      )}
    </Stack>
  );
};

export default AddQuestionsStep;
